import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { HomePage } from "./routes/HomePage";
import { ResultPage } from "./routes/ResultPage";
import { OverlayPage } from "./routes/OverlayPage";
import { HistoryPage } from "./routes/HistoryPage";
import { NotFoundPage } from "./routes/NotFoundPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "result/:sessionId", element: <ResultPage /> },
      { path: "overlay/:recordId", element: <OverlayPage /> },
      { path: "history", element: <HistoryPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);